import React from "react";
import {Dialog as GenericDialog, GenericDialogProps} from "../../dialog";
import {ProposalCommonProps, ProposalContent, UploadProposalActionButtons} from "./index";
import CommonLoader from "../../CommonLoader";


export interface UploadProposalPopUp extends ProposalCommonProps {
}


export default function UploadProposalPopUp(props: UploadProposalPopUp) {
    const {open, proposalUpdate, setUploadProposalPopUp} = props;
    const [hasReports, setHasReports] = React.useState(false); // has files
    const [fileName, setFileName] = React.useState(""); // has client upload proposal at least one file
    const [loading, setLoading] = React.useState(false);
    const handleClose = () => {
        setUploadProposalPopUp(false);
    };

    const dialogProps: GenericDialogProps = {
        actions: (
            !loading && <UploadProposalActionButtons fileName={fileName} hasReports={hasReports} proposalUpdate={proposalUpdate} loading={loading}/>
        ),
        "aria-labelledby": "upload_proposal-pop-up-form-dialog-title",
        fullWidth: true,
        maxWidth: "md",
        content: (loading ? <CommonLoader /> : <ProposalContent setLoading={setLoading} {...props} fileName={fileName} setFileName={setFileName} setHasReports={setHasReports}/>),
        dividers: true,
        onClose: handleClose,
        open,
        title: loading ?  "Wait, while we are processing your request..." : "Upload New or Re-Send Proposal For Approval",
    };

    return (
        <>
            {
                open &&
                <GenericDialog {...dialogProps} />
            }
        </>
    );
};




